import {Breadcrumb, Card} from "antd";
import {Link} from "react-router-dom";
import {IconSet} from "../components/icons";

export default function DokumentationView(props: any) {

    const breadcrumb = (
        <Breadcrumb style={{paddingTop: 6, paddingBottom: 6}}>
            <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
            <Breadcrumb.Item>Handbuch</Breadcrumb.Item>
        </Breadcrumb>
    )

    const bugMailSubject = "[BugReport]: Was ist das Problem?"
    const bugMailBody = "Hallo ITP-Support,\n" +
        "folgendes Problem ist mir aufgefallen:\n" +
        "\n" +
        "Breadcrumb: z.b. Home/Kunde/Testkunde\n" +
        "Der Breadcrumb findet sich im oberen Bereich des Hauptdialogs. Diese Angabe hilft uns das betroffene Fenster/den betroffenen Datensatz schneller zu finden.\n\n" +
        "Was war mein Ziel?\n" +
        "Hier hilft uns eine möglichst genaue Beschreibung der geplanten Tätigkeit, um diese nachstellen zu können.\n" +
        "    - Z.B. Ich wollte die Adresse des Kundendatensatz anpassen\n" +
        "\n" +
        "Was ist mein erwartetes Ergebnis?\n" +
        "Was sollte passieren? Diese Information benötigen wir, um evtl. unerwartete Workflows oder neue Anforderungen zu erkennen.\n" +
        "    - Ich wollte den angepassten Datensatz speichern.\n" +
        "\n" +
        "Was war das reale Ergebnis?\n" +
        "Hier ist eine möglichst präzise Beschreibung des Fehlverhaltens hilfreich. Gerne können auch Screenshots beigefügt werden.\n" +
        "    - Die Änderung wurde nicht gespeichert.\n" +
        "    - Es kam die Fehlermeldung „Der Datensatz ist nicht vorhanden“\n"


    return (
        <>
            {breadcrumb}
            <Card
                title={<><IconSet type='documentation'/> Handbuch</>}
            >
                <p>
                    Alle Informationen, Hinweise und Anleitungen zu [MPExpert] finden Sie in unserem
                    <a href={'https://wiki.itp-consult.de/bin/view/%5BMPExpert%5D/Grundlegende%20Elemente/'} target="_blank" rel="noopener noreferrer"> Wiki</a>.
                </p>

                <p>
                    Nutzername: beconsult
                    <br/>
                    Passwort: MPExpert!2021
                </p>
                <br/>
                <br/>
                <p>
                    Bugs und Fehler melden Sie bitte per E-Mail an <a href={
                    'mailto:support@itp-consult.de?cc=MPE@bendergruppe.com&subject='
                    + bugMailSubject
                    + '&body='
                    + bugMailBody.replaceAll("\n", "%0D%0A")
                }> support@itp-consult.de</a>
                </p>
            </Card>
        </>
    )
}
